import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class ReportSamaryService extends DatabaseGwService {
  URL_PATH: string ='/report-sale-summary';

}
